export enum SopType {
	COPY = 'copy',
	PARTICLES_SYSTEM_GPU = 'particlesSystemGpu',
	PHYSICS_WORLD = 'physicsWorld',
	SHEAR = 'shear',
	TRANSFORM = 'transform',
	UV_LAYOUT = 'uvLayout',
	UV_TRANSFORM = 'uvTransform',
	UV_UNWRAP = 'uvUnwrap',
}

export enum SopTypeFile {
	FILE_DRC = 'fileDRC',
	FILE_FBX = 'fileFBX',
	FILE_GLTF = 'fileGLTF',
	FILE_JSON = 'fileJSON',
	FILE_MPD = 'fileMPD',
	FILE_OBJ = 'fileOBJ',
	FILE_PDB = 'filePDB',
	FILE_PLY = 'filePLY',
	FILE_STL = 'fileSTL',
	FILE_SVG = 'fileSVG',
}

export enum SopTypeFileMulti {
	FILE_DRC = 'fileMultiDRC',
	FILE_FBX = 'fileMultiFBX',
	FILE_GLTF = 'fileMultiGLTF',
	FILE_JSON = 'fileMultiJSON',
	FILE_MPD = 'fileMultiMPD',
	FILE_OBJ = 'fileMultiOBJ',
	FILE_PDB = 'fileMultiPDB',
	FILE_PLY = 'fileMultiPLY',
	FILE_STL = 'fileMultiSTL',
	FILE_SVG = 'fileMultiSVG',
}
